import { PlanDefinition, PlanTier } from "@/lib/types/billing.types";

export const BILLING_PLANS: Record<
  Exclude<PlanTier, "enterprise">,
  PlanDefinition
> = {
  free: {
    name: "Free",
    tier: "free",
    clickLimit: 1500,
    webhookLimit: 0,
    monthlyPrice: 0,
    features: ["1 app", "Basic analytics", "50 short links/month"],
  },
  starter: {
    name: "Starter",
    tier: "starter",
    clickLimit: 70000,
    webhookLimit: 3,
    monthlyPrice: 19,
    paygPricePer1kCents: 30,
    paddleMonthlyPriceId:
      process.env.NEXT_PUBLIC_PADDLE_STARTER_MONTHLY_PRICE_ID,
    paddleYearlyPriceId: process.env.NEXT_PUBLIC_PADDLE_STARTER_YEARLY_PRICE_ID,
    paddleMonthlyNoTrialPriceId:
      process.env.NEXT_PUBLIC_PADDLE_STARTER_MONTHLY_NO_TRIAL_PRICE_ID,
    paddleYearlyNoTrialPriceId:
      process.env.NEXT_PUBLIC_PADDLE_STARTER_YEARLY_NO_TRIAL_PRICE_ID,
    features: [
      "Unlimited apps",
      "Unlimited short links",
      "3 webhooks",
      "Basic support",
      "Expanded analytics",
    ],
  },
  scale: {
    name: "Scale",
    tier: "scale",
    clickLimit: 350000,
    webhookLimit: 10,
    monthlyPrice: 79,
    paygPricePer1kCents: 15,
    paddleMonthlyPriceId: process.env.NEXT_PUBLIC_PADDLE_SCALE_MONTHLY_PRICE_ID,
    paddleYearlyPriceId: process.env.NEXT_PUBLIC_PADDLE_SCALE_YEARLY_PRICE_ID,
    features: ["Custom domain", "10 webhooks", "Priority support"],
  },
};

export const ENTERPRISE_PLAN_NAME = "Enterprise";

export const TRANSACTION_PAGE_SIZE = 10;

export const BILLING_INTERVALS = {
  month: "Monthly",
  year: "Yearly",
} as const;
